<template>
    <div></div>
    <!-- Your component template -->
  </template>
  
  <script>
  export default {
    data () {
            return {
                countDown: 100000000
            }
        },
        methods: {
            countDownTimer () {
                if (this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            }
        },
        created () {
            this.countDownTimer()
        }
  };
  </script>